import React from 'react'
import ServiceHero from './ServiceHero'
import ServiceM from './ServiceM'
import Navbar from '../../Components/Navbar/Navbar'
import Footer from '../../Components/Footer/Footer';
import Zero_Touch_Main_Section from '../../Pages/Zero_touch_home_section/zero_touch_men_section.jsx';

const Service = () => {
  return (
    <div>
    <Navbar></Navbar>
       <ServiceHero></ServiceHero>
      <Zero_Touch_Main_Section />
        <ServiceM></ServiceM>
        <Footer></Footer>
        </div>
  )
}

export default Service